import { c as _c } from "react/compiler-runtime";
import { StoreImageEnum, StoreItemStyleEnum, getCommonItem } from '@systemeio/digital-store-shared';
import { FormInput } from '@systemeio/ui';
import ItemSteps from 'modules/stores/store/components/item-steps';
import StoreImageSelector from 'modules/stores/store/components/store-image-selector';
import { PhysicalProductItemEditType, PhysicalProductItemErrorsType, ProductDownloadItemEditType, ProductDownloadItemErrorsType, ProductECourseItemEditType, ProductECourseItemErrorsType } from 'modules/stores/store/content/product/types/product-interface';
import { useStorePreviewContext } from 'modules/stores/store/context/store-preview-context';
import React, { Dispatch, SetStateAction, useEffect } from 'react';
import FormTextarea from 'shared/components/form-textarea';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface Props<StateType extends ProductDownloadItemEditType | ProductECourseItemEditType | PhysicalProductItemEditType, ErrorsType extends ProductDownloadItemErrorsType | ProductECourseItemErrorsType | PhysicalProductItemErrorsType> {
  tempState: StateType;
  setTempState: Dispatch<SetStateAction<StateType>>;
  errors: ErrorsType;
  imageType: StoreImageEnum;
}
const Thumbnail = t0 => {
  const $ = _c(63);
  const {
    tempState,
    setTempState,
    errors,
    imageType
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    setPreview,
    setSingleItemMode
  } = useStorePreviewContext();
  let t1;
  let t2;
  if ($[0] !== setPreview || $[1] !== setSingleItemMode || $[2] !== tempState) {
    t1 = () => {
      setPreview([getCommonItem(tempState)]);
      setSingleItemMode(true);
    };
    t2 = [setPreview, setSingleItemMode, tempState];
    $[0] = setPreview;
    $[1] = setSingleItemMode;
    $[2] = tempState;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== setTempState) {
    t3 = () => {
      setTempState(_temp);
    };
    $[5] = setTempState;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] !== t) {
    t5 = t("dashboard.store.image.select_header_image");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = tempState.thumbnail;
  let t7;
  if ($[10] !== t) {
    t7 = t("dashboard.store.image.thumbnail");
    $[10] = t;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== setTempState) {
    t8 = dataFile => setTempState(prev_0 => ({
      ...prev_0,
      thumbnail: dataFile
    }));
    $[12] = setTempState;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== imageType || $[15] !== t7 || $[16] !== t8 || $[17] !== tempState.thumbnail) {
    t9 = <StoreImageSelector dataFile={t6} imageType={imageType} label={t7} onChange={t8} />;
    $[14] = imageType;
    $[15] = t7;
    $[16] = t8;
    $[17] = tempState.thumbnail;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t5 || $[20] !== t9) {
    t10 = {
      key: "image",
      title: t5,
      element: t9
    };
    $[19] = t5;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t) {
    t11 = t("dashboard.store.item.add_text");
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  const t12 = tempState.title;
  let t13;
  if ($[24] !== t) {
    t13 = t("dashboard.store.item.title");
    $[24] = t;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== setTempState) {
    t14 = t15 => {
      const {
        target: t16
      } = t15;
      const {
        value
      } = t16;
      return setTempState(prev_1 => ({
        ...prev_1,
        title: value
      }));
    };
    $[26] = setTempState;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== errors.title || $[29] !== t13 || $[30] !== t14 || $[31] !== tempState.title) {
    t15 = <FormInput required={true} value={t12} label={t13} onChange={t14} error={errors.title} />;
    $[28] = errors.title;
    $[29] = t13;
    $[30] = t14;
    $[31] = tempState.title;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  const t16 = tempState.buttonTitle;
  let t17;
  if ($[33] !== t) {
    t17 = t("dashboard.store.item.button");
    $[33] = t;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== setTempState) {
    t18 = t19 => {
      const {
        target: t20
      } = t19;
      const {
        value: value_0
      } = t20;
      return setTempState(prev_2 => ({
        ...prev_2,
        buttonTitle: value_0
      }));
    };
    $[35] = setTempState;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== errors.buttonTitle || $[38] !== t17 || $[39] !== t18 || $[40] !== tempState.buttonTitle) {
    t19 = <FormInput required={true} value={t16} label={t17} onChange={t18} error={errors.buttonTitle} />;
    $[37] = errors.buttonTitle;
    $[38] = t17;
    $[39] = t18;
    $[40] = tempState.buttonTitle;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== t15 || $[43] !== t19) {
    t20 = <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">{t15}{t19}</div>;
    $[42] = t15;
    $[43] = t19;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  const t21 = tempState.subTitle;
  let t22;
  if ($[45] !== t) {
    t22 = t("dashboard.store.item.subtitle");
    $[45] = t;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] !== setTempState) {
    t23 = t24 => {
      const {
        target: t25
      } = t24;
      const {
        value: value_1
      } = t25;
      return setTempState(prev_3 => ({
        ...prev_3,
        subTitle: value_1
      }));
    };
    $[47] = setTempState;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  let t24;
  if ($[49] !== errors.subTitle || $[50] !== t22 || $[51] !== t23 || $[52] !== tempState.subTitle) {
    t24 = <FormTextarea required={true} value={t21} label={t22} onChange={t23} error={errors.subTitle} />;
    $[49] = errors.subTitle;
    $[50] = t22;
    $[51] = t23;
    $[52] = tempState.subTitle;
    $[53] = t24;
  } else {
    t24 = $[53];
  }
  let t25;
  if ($[54] !== t20 || $[55] !== t24) {
    t25 = <div className="flex flex-col gap-5">{t20}{t24}</div>;
    $[54] = t20;
    $[55] = t24;
    $[56] = t25;
  } else {
    t25 = $[56];
  }
  let t26;
  if ($[57] !== t11 || $[58] !== t25) {
    t26 = {
      key: "text",
      title: t11,
      element: t25
    };
    $[57] = t11;
    $[58] = t25;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] !== t10 || $[61] !== t26) {
    t27 = <ItemSteps steps={[t10, t26]} />;
    $[60] = t10;
    $[61] = t26;
    $[62] = t27;
  } else {
    t27 = $[62];
  }
  return t27;
};
export default Thumbnail;
function _temp(prev) {
  return {
    ...prev,
    style: StoreItemStyleEnum.callout
  };
}